// Notification.js
// import { messaging } from "./helpers/firebaseInitial";
// import { getToken, onMessage } from "./helpers/firebaseInitial";
// import { doc, updateDoc } from "firebase/firestore";
// import {db} from './helpers/firebaseInitial'


// export const requestPermission = async () => {
//   try {
//     const permission = await Notification.requestPermission();
//     if (permission === "granted")
//     {
//       const token = await getToken(messaging, {
//         vapidKey: "BILIjbUfCJukevQUUL94f6nSLuVy6YcTxD9N1QgbDFnEkrEAjZFFcIGNgCa0JyniiG0EUlYBbSNzS4bWAMBVPDM",
//       });
//       console.log("FCM Token:", token);
//       // Update device token in users DB using Firebase
//       localStorage.setItem("device_token", token);
//       const userId = JSON.parse(localStorage.getItem("authUser")).id;
//       const userRef = doc(db, "users", String(userId));
//       await updateDoc(userRef, {
//         deviceToken: token,
//       });
//       console.log("Device token updated successfully.");
//     } else {
//       console.log("Notification permission not granted.");
//     }
//   } catch (error) {
//     console.error("Error getting notification permission:", error);
//   }
// };

// export const listenForMessages = () => {
//   onMessage(messaging, (payload) => {
//     console.log("Foreground message received:", payload);
//     const { title, body } = payload.data;
//     try{
//     new Notification(title, { body }, 'hello' );
//     alert("hellllololoo")
//     console.log("success")
//     }catch(error){
//         console.log("Error displaying notification:", error);
//     }
//   });
// };

import { messaging } from "./helpers/firebaseInitial";
import { getToken, onMessage } from "./helpers/firebaseInitial";
import { doc, updateDoc,  onSnapshot } from "firebase/firestore";
// import { toast } from "react-toastify";
import DefaultImage from './user.png'
import { toast } from 'react-hot-toast';
import "react-toastify/dist/ReactToastify.css";
import './Notification.css'
import { db } from "./helpers/firebaseInitial";

// Request notification permission and save token
export const requestPermission = async () => {
  try {
    const permission = await Notification.requestPermission();
    if (permission === "granted") {
      const token = await getToken(messaging, {
        vapidKey: "BHFUIBltQomO9PhS8syuAc-KthjWDObSs4x0z8HSHiKhDbEmAsXaVsnzbwqTOJY8b6Lbtv_ttTJLvZhuEHygmOA",
      });
      console.log("FCM Token:", token);
      localStorage.setItem("device_token", token);
      const userId = JSON.parse(localStorage.getItem("authUser")).id;
      const userRef = doc(db, "users", String(userId));
      await updateDoc(userRef, {
        deviceToken: token,
      });
      console.log("Device token updated successfully.----");
    } else {
      console.log("Notification permission not granted.");
    }
  } catch (error) {
    console.error("Error getting notification permission:", error);
  }
};

// Listen for foreground messages
// export const listenForMessages = () => {
//   onMessage(messaging, (payload) => {
//     console.log("Foreground message received:", payload);
//     const { title, body } = payload.data || payload.notification || {};

//     try {
//       toast.info(<>
//       <img
//             src={DefaultImage} // Replace with your default image
//             alt="notification icon"
//             style={{ width: 40, height: 40, borderRadius: "50%", marginRight: 10 }}
//           />
//       <strong>{title}</strong><div>{body}</div></>, {
//         position: "top-right",
//         autoClose: 5000,
//         hideProgressBar: false,
//         pauseOnHover: true,
//         draggable: true,
//         theme: "light"
//       });
//     } catch (error) {
//       console.log("Error displaying toast notification:", error);
//     }
//   });
// };


// export const listenForMessages = () => {
//   onMessage(messaging, (payload) => {
//     console.log("Foreground message received:", payload);
//     const { title, body } = payload.data || payload.notification || {};

//     try {
//       toast.custom((t) => (
//         <div
//           className={`${
//             t.visible ? 'animate-enter' : 'animate-leave'
//           } max-w-md w-full bg-white shadow-lg rounded-lg pointer-events-auto flex ring-1 ring-black ring-opacity-5 p-4`}
//         >
//           <div className="flex-shrink-0">
//             <img
//               src={DefaultImage}
//               alt="notification icon"
//               style={{ width: 40, height: 40, borderRadius: "50%", marginRight: 10 }}
//             />
//           </div>
//           <div className="ml-3 w-0 flex-1">
//             <p className="text-sm font-medium text-gray-900">{title}</p>
//             <p className="mt-1 text-sm text-gray-500">{body}</p>
//           </div>
//         </div>
//       ));
//     } catch (error) {
//       console.error("Error displaying toast notification:", error);
//     }
//   });
// };


export const listenForMessages = () => {
  // This function is now disabled to prevent duplicate notifications
  // The notification handling is now done in firebaseInitial.jsx
  console.log("listenForMessages disabled - using firebaseInitial.jsx for notifications");
};
